import { createApp } from './main'

let lang
const hrefLang = new URL(location.href).searchParams.get('lang')

if (hrefLang) {
  lang = hrefLang === 'pt' ? 'pt' : 'en'
} else if (navigator?.language) {
  lang = navigator.language.startsWith('pt') ? 'pt' : 'en'
} else {
  lang = 'pt'
}

const { app, router } = createApp(null, { baseUrl: location.origin, lang })

router.isReady().then(() => {
  app.mount('#app')
})
